module.exports = __webpack_public_path__ + "img/0x340720c7107ef5721e44ed2ea8e314cce5c130fa.74ab5e2f.png";